import React from 'react';
import { Button, Avatar, message } from 'antd';
import { UserOutlined, UploadOutlined } from '@ant-design/icons';

const SingleFileUpload = ({ url, onUploadSuccess, disabled, maxFileSizeMB = 3 }) => {
    
    const handleUpload = () => {
        if (disabled) return;

        const maxBytes = Number(maxFileSizeMB) * 1024 * 1024;

        window.cloudinary.openUploadWidget(
            {
                cloudName: process.env.REACT_APP_CLOUDINARY_NAME,
                uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET,
                multiple: false,
                resourceType: "image",
                sources: ["local"],
                maxFileSize: maxBytes,
                max_file_size: maxBytes,
            },
            (error, result) => {
                if (error) {
                    message.error("Upload failed");
                    return;
                }

                if (result && result.event === "success") {
                    const info = result.info || {};

                    if (typeof info.bytes === 'number' && info.bytes > maxBytes) {
                        message.error(`File is too large. Maximum allowed is ${maxFileSizeMB} MB.`);
                        return;
                    }

                    const newUrl = info.secure_url;
                    onUploadSuccess(newUrl);
                }
            }
        );
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
            <Avatar 
                size={120} 
                src={url} 
                icon={<UserOutlined />} 
                style={{ border: '2px solid #f0f0f0', marginBottom: '8px' }}
            />

            <div style={{ color: '#888', fontSize: '12px', marginBottom: '8px' }}>
                Maximum file size: {maxFileSizeMB} MB
            </div>

            <Button 
                icon={<UploadOutlined />} 
                onClick={handleUpload} 
                size="small"
                disabled={disabled}
            >
                Change Photo
            </Button>
        </div>
    );
};

export default SingleFileUpload;